import { useEffect, useState } from 'react';
import Navigation from '../product/components/Navigation';
import Footer from '../product/components/Footer';

export default function ProductWakasa5() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const products = [
    {
      id: 1,
      mainImage: 'https://static.readdy.ai/image/e93b888249cd5ed3fa57251c14e7e46c/13aad4aadbf193dd9aa53d2d6d7f3c4c.png',
      images: [
        'https://static.readdy.ai/image/e93b888249cd5ed3fa57251c14e7e46c/501eafee130b64622fdcb416db40ac76.png',
        'https://static.readdy.ai/image/e93b888249cd5ed3fa57251c14e7e46c/e90ed11a3b1710bbcd719d67c9bfd3cc.png',
        'https://static.readdy.ai/image/e93b888249cd5ed3fa57251c14e7e46c/6e44f1354e4fad60cf31535b9f01526e.png'
      ],
      name: '01 L9000'
    },
    {
      id: 2,
      mainImage: 'https://static.readdy.ai/image/e93b888249cd5ed3fa57251c14e7e46c/7c5ee84362e7fdaeb4b4abab712379b2.png',
      images: [
        'https://static.readdy.ai/image/e93b888249cd5ed3fa57251c14e7e46c/e7b031b36490a70a24bdef598f75ac9f.png',
        'https://static.readdy.ai/image/e93b888249cd5ed3fa57251c14e7e46c/290cec5aeec7f48d3ecce3905ec47899.png',
        'https://static.readdy.ai/image/e93b888249cd5ed3fa57251c14e7e46c/1506162ca5b7284a7ef41029787ed6d0.png'
      ],
      name: '02 A87048T'
    },
    {
      id: 3,
      mainImage: 'https://static.readdy.ai/image/e93b888249cd5ed3fa57251c14e7e46c/a59d3a3f2e3086cafb83c1e8d3b94259.png',
      images: [
        'https://static.readdy.ai/image/e93b888249cd5ed3fa57251c14e7e46c/c5de2ce55804a215ed49cca5bfe881c7.png',
        'https://static.readdy.ai/image/e93b888249cd5ed3fa57251c14e7e46c/1f3b14773b93c8377ac192fdc85361c3.png',
        'https://static.readdy.ai/image/e93b888249cd5ed3fa57251c14e7e46c/95a6efaead14a6f603a2fcf915708ae7.png'
      ],
      name: '03 C83003T マット'
    },
    {
      id: 4,
      mainImage: 'https://static.readdy.ai/image/e93b888249cd5ed3fa57251c14e7e46c/2193c3693c533bb0f07182a717a2f24f.png',
      images: [
        'https://static.readdy.ai/image/e93b888249cd5ed3fa57251c14e7e46c/a2c33ca35b4c0bcf0be2846d6bbeee01.png',
        'https://static.readdy.ai/image/e93b888249cd5ed3fa57251c14e7e46c/8e4e7af63885cad05e309174f5f2dd67.png',
        'https://static.readdy.ai/image/e93b888249cd5ed3fa57251c14e7e46c/a7131af9cbcdfd9a9664bf2116d2c163.png'
      ],
      name: '04 GX5-013'
    },
    {
      id: 5,
      mainImage: 'https://static.readdy.ai/image/e93b888249cd5ed3fa57251c14e7e46c/29fa0a1b887c7a5473184f24744a93b5.png',
      images: [
        'https://static.readdy.ai/image/e93b888249cd5ed3fa57251c14e7e46c/2dcb69bc297e99312dedfc3d58cd99aa.png',
        'https://static.readdy.ai/image/e93b888249cd5ed3fa57251c14e7e46c/820aba68fd9af98d5a1689c4da06d398.png',
        'https://static.readdy.ai/image/e93b888249cd5ed3fa57251c14e7e46c/df75eba81cd4fc52b0d56ee55cd002f0.png'
      ],
      name: '05 B62003T マット'
    },
    {
      id: 6,
      mainImage: 'https://static.readdy.ai/image/e93b888249cd5ed3fa57251c14e7e46c/94a8858eefdbe0faf11fdd3e4b0581f5.png',
      images: [
        'https://static.readdy.ai/image/e93b888249cd5ed3fa57251c14e7e46c/e9d33067e93682785bf9356d8f1307a9.png',
        'https://static.readdy.ai/image/e93b888249cd5ed3fa57251c14e7e46c/e34b0d0537327d76efdbf5bced93ebc3.png',
        'https://static.readdy.ai/image/e93b888249cd5ed3fa57251c14e7e46c/2bd5fe066aec0352adabd2c2645fa97d.png'
      ],
      name: '06 B62001T'
    }
  ];

  return (
    <div className="min-h-screen bg-white font-['Noto_Sans_JP']">
      <Navigation scrolled={scrolled} />
      
      <main className="pt-20">
        <div className="max-w-7xl mx-auto px-6 lg:px-12 py-12">
          {/* Breadcrumb */}
          <div className="mb-8">
            <nav className="flex items-center space-x-2 text-sm text-gray-600">
              <a href="/" className="hover:text-gray-900 transition-colors cursor-pointer">
                トップページ
              </a>
              <span>&gt;</span>
              <a href="https://www.1994real.com/catalog.html" target="_blank" rel="noopener noreferrer" className="hover:text-gray-900 transition-colors cursor-pointer">
                カタログ
              </a>
              <span>&gt;</span>
              <span className="text-gray-900">温故知新 若狭 伍 全6色 6(colors)</span>
            </nav>
          </div>

          {/* Product Header */}
          <div className="mb-12">
            <div className="flex flex-col lg:flex-row lg:items-start lg:justify-between gap-6">
              <div>
                <h1 className="font-['Noto_Serif_JP'] text-3xl lg:text-4xl font-bold text-gray-900 mb-4">
                  温故知新 若狭 伍 全6色 6(colors)
                </h1>
              </div>
              <div className="bg-gray-50 rounded-lg p-6 lg:min-w-[300px]">
                <table className="w-full text-sm">
                  <tbody>
                    <tr className="border-b border-gray-200">
                      <th className="text-left py-3 pr-4 font-medium text-gray-700">frame</th>
                      <td className="py-3 text-gray-900">48□23-143</td>
                    </tr>
                    <tr>
                      <th className="text-left py-3 pr-4 font-medium text-gray-700">希望小売価格</th>
                      <td className="py-3 text-gray-900 font-bold">129,800円(税込)</td>
                    </tr>
                  </tbody>
                </table>
                <p className="text-xs text-gray-600 mt-4">
                  写真をクリックすると拡大してご覧になれます<br />
                  詳細は<a href="https://ameblo.jp/real-inouefumihide/" target="_blank" rel="noopener noreferrer" className="text-gray-900 underline hover:text-gray-600 cursor-pointer">ブログ</a>にて紹介しています
                </p>
              </div>
            </div>
          </div>

          {/* Product Gallery */}
          <div className="space-y-16">
            {products.map((product) => (
              <div key={product.id} className="border-b border-gray-200 pb-16 last:border-b-0">
                {/* Main Image */}
                <div className="mb-8">
                  <div className="relative w-full px-8 md:px-16 lg:px-24">
                    <div className="relative bg-gradient-to-br from-gray-50 to-gray-100 rounded-2xl overflow-hidden shadow-lg hover:shadow-xl transition-shadow duration-300">
                      <div className="aspect-[4/3] flex items-center justify-center p-8 md:p-12">
                        <img
                          src={product.mainImage}
                          alt={product.name}
                          className="max-w-full max-h-full object-contain cursor-pointer hover:scale-105 transition-transform duration-500"
                          onClick={() => window.open(product.mainImage, '_blank')}
                        />
                      </div>
                    </div>
                  </div>
                </div>

                {/* Thumbnail Images */}
                <div className="grid grid-cols-3 gap-4">
                  {product.images.map((image, index) => (
                    <div key={index} className="text-center">
                      <div className="w-full h-[300px] bg-gray-100 rounded-lg overflow-hidden mb-2">
                        <img
                          src={image}
                          alt={`${product.name} - ${index + 1}`}
                          className="w-full h-full object-cover cursor-pointer hover:opacity-80 transition-opacity"
                          onClick={() => window.open(image, '_blank')}
                        />
                      </div>
                      <p className="text-sm text-gray-700">{product.name}</p>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>

          {/* Back to Catalog Button */}
          <div className="mt-12 text-center">
            <a
              href="https://real1994.official.ec/categories/4659620"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block bg-gray-900 text-white px-8 py-3 rounded-full text-sm font-medium hover:bg-gray-800 transition-colors whitespace-nowrap cursor-pointer"
            >
              ONLINE STORE
            </a>
          </div>
        </div>

        {/* Page Top Button */}
        <button
          onClick={scrollToTop}
          className="fixed bottom-8 right-8 w-12 h-12 bg-gray-900 text-white rounded-full flex items-center justify-center hover:bg-gray-800 transition-colors shadow-lg cursor-pointer z-40"
        >
          <i className="ri-arrow-up-line text-xl"></i>
        </button>
      </main>

      <Footer />
    </div>
  );
}
